<template>
  <v-container style="max-height:calc(100vh - 50px);height:calc(100vh - 50px);max-width:1400px; " class="my-0 py-0 px-0" >
    <AddDevelopmentItem v-if="visible" :data="data"/>
    <v-row no gutters class="pa-0 ma-0" style="max-height:inherit; height:inherit;max-width:1400px;margin:0 auto !important;">
      <v-col cols="4" class="pa-0 dev-column border-left" style="">
        <v-row no-gutters class="dev-header pb-2 pt-4 px-2">
          <v-col cols="6" class="  mb-0">
            <span >Tulossa</span>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn @click="newItem()" small  class="add-button avecor-button-global ml-4" >Lisää tehtävä</v-btn>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="upcomingPanel"
          multiple
          accordion
        >
          <v-expansion-panel
            v-for="(item,i) in upcoming"
            :key="i"
            @click.prevent
            
          >
            <v-expansion-panel-header  class="ma-0 pa-0" hide-actions :ref="item.id+'-header'" :id="item.id+'-header'" >
              <!-- <div :ref="item.id+'-header'"> -->
                <span class="pl-1">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar :color="userColors[item.created_by] ? userColors[item.created_by] : 'red'" style="height:20px;width:20px;min-width:20px;" v-bind="attrs"
                        v-on="on">
                        <span class="white--text text-h5" style="font-size:9px !important;">{{getInitials(item)}}</span>
                      </v-avatar>
                      
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(user, index) in [{'id':'y9ZVH4HpzFWuS9TzONQUJadQZ4T2','name':'Miko'},{'id':'wcMZF1c4vsMZAmCsXzSDDwh4PJd2','name':'Anu'},{'id':'p2VRFkTz4JUzqkGoTPUt4CWQAxa2','name':'Tomi'}]"
                        :key="index"
                      >
                        <v-list-item-title style="width:100px;padding-left:20px;cursor:pointer" @click="setUser(item.id,user.id)">{{ user.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-avatar :color="userColors[user.uid] ? userColors[user.uid] : 'red'" style="height:20px;width:20px;min-width:20px;">
                    <span class="white--text text-h5" style="font-size:9px !important;">{{getInitials(item)}}</span>
                  </v-avatar> -->
                </span>
                <span class="pl-2 pr-1 pt-1 dev-item-header-span" >{{item.name}}</span>
                <span class="pr-1 text-right dev-item-options-span">
                  
                  <div style="line-height:20px;text-align:right">
                    <v-icon size="8" @click.stop="editItem(item.id)" class="pr-1">fas fa-pencil-alt</v-icon>
                    <v-icon size="8" @click.stop="deleteItem(item.id)" class="pr-1">fas fa-trash</v-icon>
                    <v-icon v-if="item.prio_level == 1" :size="8" @click.stop="setPrioLevel(item.id, 0)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 1" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 1 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 2" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 2" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 2 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 3" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 3" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 3 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 4" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 4" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 4 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 5" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 5" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 5 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>

                  </div>
                  <div style="line-height:20px;">
                    <select :value="item.status" class="status-select" style="" @click.stop @change="event => changeStatus(item.id,event)">
                      <option value="upcoming">Tulossa</option>
                      <option value="inProgress">Kehityksessä</option>
                      <option value="done">Valmis</option>
                    </select>  
                  </div>
                </span>
              <!-- </div> -->
              <template v-slot:actions>
                <v-btn icon class="pr-3">
                  <v-icon>fa-solidd fa-caret-down</v-icon>
                </v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="dev-item-content pb-3">
              <span v-html="item.description"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="4" class="pa-0 dev-column border-left" style="background:#FFF; overflow-y:scroll;overflow-x:hidden;">
        <div class="dev-header px-4 pb-2  pt-4 mb-0" >Kehityksessä</div>
        <v-expansion-panels
          v-model="inProgressPanel"
          multiple
          accordion
        >
          <v-expansion-panel
            v-for="(item,i) in inProgress"
            :key="i"
            @click.prevent
            height="30"
          >
            <v-expansion-panel-header  class="ma-0 pa-0" hide-actions :ref="item.id+'-header'" :id="item.id+'-header'">
              <span class="pl-1">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar :color="userColors[item.created_by] ? userColors[item.created_by] : 'red'" style="height:20px;width:20px;min-width:20px;" v-bind="attrs"
                      v-on="on">
                      <span class="white--text text-h5" style="font-size:9px !important;">{{getInitials(item)}}</span>
                    </v-avatar>
                    
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(user, index) in [{'id':'y9ZVH4HpzFWuS9TzONQUJadQZ4T2','name':'Miko'},{'id':'wcMZF1c4vsMZAmCsXzSDDwh4PJd2','name':'Anu'},{'id':'p2VRFkTz4JUzqkGoTPUt4CWQAxa2','name':'Tomi'}]"
                      :key="index"
                    >
                      <v-list-item-title style="width:100px;padding-left:20px;cursor:pointer" @click="setUser(item.id,user.id)">{{ user.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </span>
              <span class="pl-3 pt-1 dev-item-header-span" >{{item.name}}</span>
              <span class="pr-1 text-right dev-item-options-span">
                <div style="line-height:20px;text-align:right">
                  <v-icon size="8" @click.stop="editItem(item.id)" class="pr-1">fas fa-pencil-alt</v-icon>
                  <v-icon size="8" @click.stop="deleteItem(item.id)" class="pr-1">fas fa-trash</v-icon>
                  <v-icon v-if="item.prio_level == 1" :size="8" @click.stop="setPrioLevel(item.id, 0)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 1" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 1 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 2" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 2" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 2 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 3" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 3" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 3 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 4" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 4" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 4 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 5" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 5" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 5 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                </div>
                <div style="line-height:20px;">
                  <select :value="item.status" class="status-select" style="" @click.stop @change="event => changeStatus(item.id,event)">
                    <option value="upcoming">Tulossa</option>
                    <option value="inProgress">Kehityksessä</option>
                    <option value="done">Valmis</option>
                  </select>  
                </div>
              </span>
              <template v-slot:actions>
                <v-btn icon class="pr-3">
                  <v-icon>fa-solidd fa-caret-down</v-icon>
                </v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="dev-item-content pb-3">
              <span v-html="item.description"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="4" class="pa-0 dev-column border-left border-right" style="background:#FFF;overflow-y:scroll;overflow-x:hidden;">
        <div class="dev-header px-4 py-2 pt-4  mb-0">
          <div style="width:40%;display:inline-block;">Valmiit</div>
          <div style="width:57%;display:inline-block;" class="text-righ">
            <v-switch
              v-model="showOlderDone"
              inset
              dense
              hide-details
              class="pa-0 ma-0"
              :label="'Näytä yli 3kk valmiit'"
            ></v-switch>
          </div>
        </div>
        <v-expansion-panels
          v-model="donePanel"
          multiple
          accordion
        >
          <v-expansion-panel
            v-for="(item,i) in done"
            :key="i"
            @click.prevent
            height="30"
          >
            <v-expansion-panel-header  class="ma-0 pa-0" hide-actions :ref="item.id+'-header'" :id="item.id+'-header'">
              <span class="pl-1">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar :color="userColors[item.created_by] ? userColors[item.created_by] : 'red'" style="height:20px;width:20px;min-width:20px;" v-bind="attrs"
                      v-on="on">
                      <span class="white--text text-h5" style="font-size:9px !important;">{{getInitials(item)}}</span>
                    </v-avatar>
                    
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(user, index) in [{'id':'y9ZVH4HpzFWuS9TzONQUJadQZ4T2','name':'Miko'},{'id':'wcMZF1c4vsMZAmCsXzSDDwh4PJd2','name':'Anu'},{'id':'p2VRFkTz4JUzqkGoTPUt4CWQAxa2','name':'Tomi'}]"
                      :key="index"
                    >
                      <v-list-item-title style="width:100px;padding-left:20px;cursor:pointer" @click="setUser(item.id,user.id)">{{ user.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </span>
              <span class="pl-3 pt-1 dev-item-header-span" >{{item.name}}</span>
              <span class="pr-1 text-right dev-item-options-span">
                <div style="line-height:20px;text-align:right">
                  <v-icon size="8" @click.stop="editItem(item.id)" class="pr-1">fas fa-pencil-alt</v-icon>
                  <v-icon size="8" @click.stop="deleteItem(item.id)" class="pr-1">fas fa-trash</v-icon>
                  <v-icon v-if="item.prio_level == 1" :size="8" @click.stop="setPrioLevel(item.id, 0)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 1" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 1 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 2" :size="8" @click.stop="setPrioLevel(item.id, 1)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 2" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 2 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 3" :size="8" @click.stop="setPrioLevel(item.id, 2)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 3" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 3 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 4" :size="8" @click.stop="setPrioLevel(item.id, 3)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 4" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 4 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-if="item.prio_level == 5" :size="8" @click.stop="setPrioLevel(item.id, 4)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level > 5" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;color:red;">fas fa-exclamation-triangle</v-icon>
                    <v-icon v-else-if="item.prio_level < 5 || !item.prio_level" :size="8" @click.stop="setPrioLevel(item.id, 5)" style="padding-right:0px;">fas fa-exclamation-triangle</v-icon>
                </div>
                <div style="line-height:20px;">
                  <select :value="item.status" class="status-select" style="" @click.stop @change="event => changeStatus(item.id,event)">
                    <option value="upcoming">Tulossa</option>
                    <option value="inProgress">Kehityksessä</option>
                    <option value="done">Valmis</option>
                  </select>  
                </div>
              </span>
              <template v-slot:actions>
                <v-btn icon class="pr-3">
                  <v-icon>fa-solidd fa-caret-down</v-icon>
                </v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="dev-item-content pb-3">
              <span v-html="item.description"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      
    </v-row>
  </v-container>  
</template>



<script>
import { mapFields } from 'vuex-map-fields'
import AddDevelopmentItem from './../blocks/AddDevelopmentItem'
import firebase from 'firebase'
var db = null


export default {
    components: {
      AddDevelopmentItem
    },
     data() {
      return {
        userColors:{
          'y9ZVH4HpzFWuS9TzONQUJadQZ4T2':'#FF9800',
          'wcMZF1c4vsMZAmCsXzSDDwh4PJd2':'#4CAF50',
          'p2VRFkTz4JUzqkGoTPUt4CWQAxa2':'#607D8B'

        },
        items:[],
        itemsMap:{},
        upcomingPanel:[],
        inProgressPanel:[],
        donePanel:[],
        data:{},
        showOlderDone:false
      }
    },
    mounted() {
      this.content = this.disabledContent
      db = firebase.firestore();
      this.initiateItems()
    },
    computed: {
      upcoming(){
        var upcoming = []
        this.items.forEach(item =>{
          item.status === 'upcoming' ? upcoming.push(item) : ''
        })
        upcoming.sort(function(a,b){
          var aPrio = a.prio_level ? a.prio_level : 0
          var bPrio = b.prio_level ? b.prio_level : 0
          return bPrio - aPrio
        });
        /* upcoming.sort(function(a,b){
          var aDate = 0
          var bDate = 0
          if(a.created_at && a.created_at.seconds){
            var aDate = new Date(a.created_at.seconds * 1000)
          }
          if(b.created_at && b.created_at.seconds){
            var bDate = new Date(b.created_at.seconds * 1000)
          }
          return  bDate - aDate
        }); */
        return upcoming
      },
      inProgress(){
        var inProgress = []
        this.items.forEach(item =>{
          item.status === 'inProgress' ? inProgress.push(item) : ''
        })
        inProgress.sort(function(a,b){
          var aPrio = a.prio_level ? a.prio_level : 0
          var bPrio = b.prio_level ? b.prio_level : 0
          return bPrio - aPrio
        });
        return inProgress
      },
      done(){
        var done = []
        var d = new Date();
        d.setMonth(d.getMonth() - 3);
        const threeMonthsPriorInSeconds = d.getTime() / 1000
        this.items.forEach(item =>{
          if(!item.done_at) return
          if(!this.showOlderDone && item.done_at.seconds > threeMonthsPriorInSeconds && item.status === 'done') done.push(item)
          else if(this.showOlderDone && item.status === 'done') done.push(item)
        })
        done.sort(function(a,b){
          var aDate = 0
          var bDate = 0
          if(a.done_at && a.done_at.seconds){
            var aDate = new Date(a.done_at.seconds * 1000)
          }
          if(b.done_at && b.done_at.seconds){
            var bDate = new Date(b.done_at.seconds * 1000)
          }
          return  bDate - aDate
        });

        return done
      },
      ...mapFields({
        settings:'settings',
        staff:'staff.staff',
        user:'user',
        visible:"modals.development.new.visible",
        selectedItemIdForEdit:"modals.development.edit.itemId",
      }),
    },
    created () {},
    methods: {
      setUser(itemId,userId){
        
        const itemRef = db.collection('devItems').doc(itemId)
        itemRef.set({
          created_by:userId,
        }, {merge: true})  
      },
      getInitials(item){
        var uid = this.user.uid
        var uid = item.created_by ? item.created_by : 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'

        var f = this.staff[uid] ? this.staff[uid].firstName.charAt(0) : ''
        var l = this.staff[uid] ? this.staff[uid].lastName.charAt(0) : ''
        return f+l

      },
      editItem(id){
        this.selectedItemIdForEdit = id; 
        this.visible = false
        this.visible = true
        this.data = this.itemsMap && this.itemsMap[id] ? this.itemsMap[id] : {}
      },
      newItem(){
        this.selectedItemIdForEdit = ''; 
        this.visible = false
        this.visible = true
      },
      changeStatus(id,event){
        var currentStatus = this.itemsMap[id].status
        var newStatus = event.target.value
        const itemRef = db.collection('devItems').doc(id)
        
        if (newStatus === currentStatus) return
        if (newStatus === 'done'){
          itemRef.set({
            status:newStatus,
            done_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid
          }, {merge: true})
        }
        else if (newStatus === 'inProgress'){
          itemRef.set({
            status:newStatus,
            in_progress_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid
          }, {merge: true})
        }
        else {
          itemRef.set({
            status:newStatus,
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid
          }, {merge: true})
        }
      },
      setPrioLevel(id, level){
        const itemRef = db.collection('devItems').doc(id)
        itemRef.set({
          prio_level:level,
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid
        }, {merge: true})
        if(this.$refs[id+'-header'] && this.$refs[id+'-header'][0]){
          
          setTimeout(() => {
            this.$refs[id+'-header'][0].$el.classList.value = this.$refs[id+'-header'][0].$el.classList.value + ' dev-item-highlight-item'
          }, 150);

          setTimeout(() => {
            this.$refs[id+'-header'][0].$el.classList.value = this.$refs[id+'-header'][0].$el.classList.value.replace('dev-item-highlight-item', '')
          }, 2000);
        }
      },
      deleteItem(id){
        var t = this
        if (confirm("Haluatko varmasti poistaa?")) {
          db.collection('devItems').doc(id).delete().then(function() {
              console.log("Document successfully deleted!");
          }).catch(function(error) {
              console.error("Error removing document: ", error);
          });
        }
      },
      createItemsArray(){
        var t = this
        var arr = []
        Object.keys(this.itemsMap).forEach(key => {
          if(key !== '7ZnpnuzwA72d7UvQiiJJ') arr.push({created_by:'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' ,...t.itemsMap[key]});
          if(key === '7ZnpnuzwA72d7UvQiiJJ' && t.user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2') arr.push({created_by:'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' ,...t.itemsMap[key]});
        });
        this.items = arr
      },
      initiateItems(){
        var t= this
        db.collection("devItems").onSnapshot(function(querySnapshot) {
            t.itemsMap = {}
            querySnapshot.forEach(function(doc) {
                t.itemsMap[doc.id] = {...doc.data(),id:doc.id}
            });
            t.createItemsArray()
        })
      },
    }
  }
</script>

<style>
.ql-tooltip  {
  z-index:100;
}
.new-note{
  
  position:absolute;
  height:40px;
  bottom:0px;
  width:100%;
  background:#fff;
}

.ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {
    padding-left: unset !important;
}
.list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
}
.list-group {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Development.vue